// @flow
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Select,
  Modal,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5, SpError, SpButton } from 'components/DesignKit';
import { validators } from 'utils/validationMessages';

const { Option } = Select;
const { TextArea } = Input;

type Props = {
  close: Function,
  submit: Function,
  visible: boolean,
  submitting: boolean,
  selectedOrder: Object,
};

const UpdateOrder = (props: Props) => {
  const {
    visible,
    close,
    submit,
    submitting,
    selectedOrder,
  } = props;

  const [, forceUpdate] = useState();
  const [internalNotes, setInternalNotes] = useState(selectedOrder && selectedOrder.adminInternalNotes);
  const [externalNotes, setExternalNotes] = useState(selectedOrder && selectedOrder.adminExternalNotes);
  const [type, setType] = useState(selectedOrder.catalogOrderStatus);
  const [disableButton, setDisableButton] = useState(false);
  const { gid } = selectedOrder;
  const nameRegex = /^[ ]*([a-zA-Z'-.]{1,}( [a-zA-z'-. ]{1,})?)$/;

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      name: {
        message: validators.integrators.validName,
        rule: val => nameRegex.test(val),
      },
    },
  }));

  useEffect(() => {
    if (!submitting) {
      setDisableButton(false);
    }
  }, [submitting]);

  const validate = (event) => {
    setDisableButton(true);
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    setDisableButton(formValid);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    submit({
      gid,
      type,
      internalNotes,
      externalNotes,
    });
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={validate} disabled={disableButton}>Update</SpButton>,
      ]}
      title="Update Order History"
    >
      <div className="px-4">
        <div className={submitting ? 'OVERLAY' : ''} />
        <div className="mb-3">
          <label htmlFor=""><SpH5>Type</SpH5></label>
          <Select
            className="w-100"
            value={type}
            onChange={(e) => setType(e)}
          >
            <Option key={1} value="PROCESSED">Processing</Option>
            <Option key={2} value="SHIPPED">Shipped</Option>
            <Option key={3} value="DELIVERED">Delivered</Option>
            <Option key={4} value="CANCELLED">Cancelled</Option>
            <Option key={5} value="RETURNED">Returned</Option>
          </Select>
          <SpError>
            {simpleValidator.current.message('Type', type, 'required')}
          </SpError>
        </div>
        <div className="mb-3">
          <label htmlFor=""><SpH5>Notes (Internal)</SpH5></label>
          <TextArea
            maxLength={255}
            rows={5}
            placeholder="Notes"
            value={internalNotes}
            onChange={(e) => setInternalNotes(e.currentTarget.value)}
          />
          <SpError>
            {simpleValidator.current.message('notes', internalNotes, 'required')}
          </SpError>
        </div>
        <div>
          <label htmlFor=""><SpH5>Notes (External)</SpH5></label>
          <TextArea
            maxLength={255}
            rows={5}
            placeholder="Notes"
            value={externalNotes}
            onChange={(e) => setExternalNotes(e.currentTarget.value)}
          />
          <SpError>
            {simpleValidator.current.message('notes', externalNotes, 'required')}
          </SpError>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
});

// $FlowFixMe
export default connect(mapStateToProps, null)(UpdateOrder);
